module.exports = __webpack_public_path__ + "img/Number=16.1183a381.png";